import { RequestHelper } from "../Helpers/RequestHelper.js";
import { DataDriver } from "../Drivers/DataDriver.js";

export class WidgetRates {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elemetId;
        this.prefixSelector = "#" + this.parentId;
        this.classAtt = "pmdrs-widget";
    }

    init() {
        let $this = this;

        $this.addHtml();
    }

    generalSettingsEnabled() {
        console.log(this.app.config.vehicle.vin);
        return this.app.config.vehicle.vin == "all";
    }

    addHtml() {
        let $this = this;

        if ($this.app.pmdrs.dataDriver.isPixelmotion()) {
            $this.addAprIframe();
        }
    }

    addAprIframe() {
        let isBmw = this.app.pmdrs.getOEM() == "bmwmotorrad";

        //get APR from pm-drs-api
        let data = {
            vin: this.app.config.vehicle.vin,
            showCriteria: false,
            isBmw: false,
        };
        var iframeUrl = this.getIframeURL();
        iframeUrl = RequestHelper.getUrl(iframeUrl, data);
        let iframeHtml = '<iframe src="' + iframeUrl + '"></iframe>';
        document.querySelector(this.app.getSelector("")).insertAdjacentHTML("beforeend", iframeHtml);
    }

    getIframeURL() {
        let isBmw = this.app.pmdrs.getOEM() == "bmwmotorrad";
        let iframeUrl = this.app.pmdrs.pmApi.getURL();

        if (this.generalSettingsEnabled()) {
            iframeUrl +=
                "/ratesheets/getAdminWidget/" +
                this.app.pmdrs.getOEM() +
                "/" +
                this.app.pmdrs.config.accountId +
                "/" +
                isBmw;
        } else {
            iframeUrl += "/ratesheets/createEdit/" + this.app.pmdrs.getOEM() + "/" + this.app.pmdrs.config.accountId;
        }

        return iframeUrl;
    }
}
